import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';
import { NotifierService } from 'angular-notifier';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { HeaderService } from 'src/app/core/header/header.service';
import { Pagination } from 'src/app/core/pagination/pagination';
import { ConfigService } from 'src/app/core/services/config.service';
import { ErrorHandlerService } from 'src/app/core/services/error-handler.service';
import { SortingService } from 'src/app/core/services/sorting.service';
import { StatusHandlerService } from 'src/app/core/services/status-handler.service';
import { ReviewCrawledDataService } from '../review-crawled-data.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-review-crawled-data-list',
  templateUrl: './review-crawled-data-list.component.html',
  styleUrls: ['./review-crawled-data-list.component.scss'],
  providers: [DatePipe]
})
export class ReviewCrawledDataListComponent implements OnInit {

  @ViewChild('clientMaster')
  public clientMaster!: NgSelectComponent;

  public totalPages: number | any;
  public currentPage: number | any;
  public pagination: Pagination | any;
  public showLoader: boolean = false;
  public errorMessage: any = null;
  public rlSearchList: any = [];
  public reviewCrawledDatalSearchList: any = [];
  public reviewCrawledDatalSearchList1: any = [];
  public reviewCrawledDatalSearchList2: any = [];
  public reviewCrawledDatalSearchList3: any = [];
  private readonly notifier: NotifierService;
  bsModalRef!: BsModalRef;
  public clientMasterOptionsList: any = [];
  public colSpan: number = 14;
  public modalRef?: BsModalRef;
  public wrapText: boolean = false;
  public columnValueList: any = null;
  public clientMasterId: any = [];
  public ProcessDate: null | string | undefined | any = new Date()
  public totalRecordsForPagination: number = 0;
  public config: PerfectScrollbarConfigInterface = {};
  public disableSendCMSBtn: boolean = true;
  public disableRejectBtn: boolean = true;
  public isSearch: boolean = false;

  public columnDropdownFilter = [
    {
      id: 1, name: 'Is equal to', activeURLConfigurationMasterID: false, activeMasterSheetId: false, activeClientName: false, activeRegLakeStatus: false, activePushToCMS: false, activeIsSeleniumRequired: false, activeCrawledMasterDataID: false, activeUrlDetailID: false, activeCreatedOn: false
      , activeCrawledJSONID: false, activeErrorMessage: false, activeSourceURLError: false, activeFieldLevelError: false, activeTotalReceivedRecords: false, activeProcessedRecords: false, activeErrorRecords: false, activeBrowserType: false, activeSourceURL: false, activeCrawledData: false
    },
    {
      id: 2, name: 'Is not equal to', activeURLConfigurationMasterID: false, activeMasterSheetId: false, activeClientName: false, activeRegLakeStatus: false, activePushToCMS: false, activeIsSeleniumRequired: false, activeCrawledMasterDataID: false, activeUrlDetailID: false, activeCreatedOn: false
      , activeCrawledJSONID: false, activeErrorMessage: false, activeSourceURLError: false, activeFieldLevelError: false, activeTotalReceivedRecords: false, activeProcessedRecords: false, activeErrorRecords: false, activeBrowserType: false, activeSourceURL: false, activeCrawledData: false
    },
    {
      id: 3, name: 'Starts with', activeURLConfigurationMasterID: false, activeMasterSheetId: false, activeClientName: false, activeRegLakeStatus: false, activePushToCMS: false, activeIsSeleniumRequired: false, activeCrawledMasterDataID: false, activeUrlDetailID: false, activeCreatedOn: false
      , activeCrawledJSONID: false, activeErrorMessage: false, activeSourceURLError: false, activeFieldLevelError: false, activeTotalReceivedRecords: false, activeProcessedRecords: false, activeErrorRecords: false, activeBrowserType: false, activeSourceURL: false, activeCrawledData: false
    },
    {
      id: 4, name: 'Contains', activeURLConfigurationMasterID: false, activeMasterSheetId: false, activeClientName: false, activeRegLakeStatus: false, activePushToCMS: false, activeIsSeleniumRequired: false, activeCrawledMasterDataID: false, activeUrlDetailID: false, activeCreatedOn: false
      , activeCrawledJSONID: false, activeErrorMessage: false, activeSourceURLError: false, activeFieldLevelError: false, activeTotalReceivedRecords: false, activeProcessedRecords: false, activeErrorRecords: false, activeBrowserType: false, activeSourceURL: false, activeCrawledData: false
    },
    {
      id: 5, name: 'Does not contain', activeURLConfigurationMasterID: false, activeMasterSheetId: false, activeClientName: false, activeRegLakeStatus: false, activePushToCMS: false, activeIsSeleniumRequired: false, activeCrawledMasterDataID: false, activeUrlDetailID: false, activeCreatedOn: false
      , activeCrawledJSONID: false, activeErrorMessage: false, activeSourceURLError: false, activeFieldLevelError: false, activeTotalReceivedRecords: false, activeProcessedRecords: false, activeErrorRecords: false, activeBrowserType: false, activeSourceURL: false, activeCrawledData: false
    },
    {
      id: 6, name: 'Ends with', activeURLConfigurationMasterID: false, activeMasterSheetId: false, activeClientName: false, activeRegLakeStatus: false, activePushToCMS: false, activeIsSeleniumRequired: false, activeCrawledMasterDataID: false, activeUrlDetailID: false, activeCreatedOn: false
      , activeCrawledJSONID: false, activeErrorMessage: false, activeSourceURLError: false, activeFieldLevelError: false, activeTotalReceivedRecords: false, activeProcessedRecords: false, activeErrorRecords: false, activeBrowserType: false, activeSourceURL: false, activeCrawledData: false
    },
    {
      id: 7, name: 'Is null', activeURLConfigurationMasterID: false, activeMasterSheetId: false, activeClientName: false, activeRegLakeStatus: false, activePushToCMS: false, activeIsSeleniumRequired: false, activeCrawledMasterDataID: false, activeUrlDetailID: false, activeCreatedOn: false
      , activeCrawledJSONID: false, activeErrorMessage: false, activeSourceURLError: false, activeFieldLevelError: false, activeTotalReceivedRecords: false, activeProcessedRecords: false, activeErrorRecords: false, activeBrowserType: false, activeSourceURL: false, activeCrawledData: false
    },
    {
      id: 8, name: 'Is not null', activeURLConfigurationMasterID: false, activeMasterSheetId: false, activeClientName: false, activeRegLakeStatus: false, activePushToCMS: false, activeIsSeleniumRequired: false, activeCrawledMasterDataID: false, activeUrlDetailID: false, activeCreatedOn: false
      , activeCrawledJSONID: false, activeErrorMessage: false, activeSourceURLError: false, activeFieldLevelError: false, activeTotalReceivedRecords: false, activeProcessedRecords: false, activeErrorRecords: false, activeBrowserType: false, activeSourceURL: false, activeCrawledData: false
    }
  ];

  public columnList = [
    { value: 1, name: 'URLConfiguration Master ID', checked: true, index: -1, text: '', columnName: 'URLConfigurationMasterID' },
    { value: 2, name: 'Master Sheet Id', checked: true, index: -1, text: '', columnName: 'MasterSheetId' },
    { value: 3, name: 'Client Name', checked: true, index: -1, text: '', columnName: 'ClientName' },
    { value: 4, name: 'Reg Lake Status', checked: true, index: -1, text: '', columnName: 'RegLakeStatus' },
    { value: 5, name: 'PushToCMS', checked: true, index: -1, text: '', columnName: 'PushToCMS' },
    { value: 6, name: 'Is Selenium Required', checked: true, index: -1, text: '', columnName: 'IsSeleniumRequired' },
    { value: 7, name: 'Browser Type', checked: true, index: -1, text: '', columnName: 'BrowserType' },
    { value: 8, name: 'Source URL', checked: true, index: -1, text: '', columnName: 'SourceURL' },
    { value: 9, name: 'Inclusion Keywords', checked: true, index: -1, text: '', columnName: 'InclusionKeywords' },
    { value: 10, name: 'Exclusion Keywords', checked: true, index: -1, text: '', columnName: 'ExclusionKeywords' },
  ]

  public columnList1 = [
    { value: 1, name: 'Crawled Master Data ID', checked: true, index: -1, text: '', columnName: 'CrawledMasterDataID' },
    { value: 2, name: 'Client Name', checked: true, index: -1, text: '', columnName: 'ClientName' },
    { value: 3, name: 'Url Detail ID', checked: true, index: -1, text: '', columnName: 'UrlDetailID' },
    { value: 4, name: 'Created On', checked: true, index: -1, text: '', columnName: 'CreatedOn' },
  ]

  public columnList2 = [
    { value: 1, name: 'Crawled JSON ID', checked: true, index: -1, text: '', columnName: 'CrawledJSONID' },
    { value: 2, name: 'URLConfiguration Master ID', checked: true, index: -1, text: '', columnName: 'URLConfigurationMasterID' },
    { value: 3, name: 'Client Name', checked: true, index: -1, text: '', columnName: 'ClientName' },
    { value: 4, name: 'Error Message', checked: true, index: -1, text: '', columnName: 'ErrorMessage' },
    { value: 5, name: 'Source URL Error', checked: true, index: -1, text: '', columnName: 'SourceURLError' },
    { value: 6, name: 'Field Level Error', checked: true, index: -1, text: '', columnName: 'FieldLevelError' },
    { value: 7, name: 'Total Received Records', checked: true, index: -1, text: '', columnName: 'TotalReceivedRecords' },
    { value: 8, name: 'Processed Records', checked: true, index: -1, text: '', columnName: 'ProcessedRecords' },
    { value: 9, name: 'Error Records', checked: true, index: -1, text: '', columnName: 'ErrorRecords' },
    { value: 10, name: 'Created On', checked: true, index: -1, text: '', columnName: 'CreatedOn' },
  ]

  public columnList3 = [
    { value: 1, name: 'Crawled JSON ID', checked: true, index: -1, text: '', columnName: 'CrawledJSONID' },
    { value: 2, name: 'URLConfiguration Master ID', checked: true, index: -1, text: '', columnName: 'URLConfigurationMasterID' },
    { value: 3, name: 'Client Name', checked: true, index: -1, text: '', columnName: 'ClientName' },
    { value: 4, name: 'Error Message', checked: true, index: -1, text: '', columnName: 'ErrorMessage' },
    { value: 5, name: 'Source URL Error', checked: true, index: -1, text: '', columnName: 'SourceURLError' },
    { value: 6, name: 'Field Level Error', checked: true, index: -1, text: '', columnName: 'FieldLevelError' },
    { value: 7, name: 'Total Received Records', checked: true, index: -1, text: '', columnName: 'TotalReceivedRecords' },
    { value: 8, name: 'Processed Records', checked: true, index: -1, text: '', columnName: 'ProcessedRecords' },
    { value: 9, name: 'Error Records', checked: true, index: -1, text: '', columnName: 'ErrorRecords' },
    { value: 10, name: 'Created On', checked: true, index: -1, text: '', columnName: 'CreatedOn' },
    { value: 11, name: 'Crawled Data', checked: true, index: -1, text: '', columnName: 'CrawledData' },
    { value: 12, name: 'Processed Data', checked: true, index: -1, text: '', columnName: 'ProcessedData' },
  ]


  constructor(private reviewCrawledDataService: ReviewCrawledDataService,
    private errorHandler: ErrorHandlerService,
    private sortingService: SortingService,
    private configService: ConfigService,
    private notifierService: NotifierService,
    private statusService: StatusHandlerService,
    private headerService: HeaderService, public modalService: BsModalService,
    private datePipe: DatePipe,
    private router: Router,
    private cd: ChangeDetectorRef) {
    this.notifier = notifierService;
  }

  GetClientMasterOptions() {
    this.showLoader = true;
    this.reviewCrawledDataService.GetClientMasterOptions().subscribe({
      next: (data: any) => {
        this.clientMasterOptionsList = data.Data;
        if (this.clientMasterOptionsList.length > 0) {
          this.clientMasterId = this.clientMasterOptionsList[0].ClientMasterID;
        }

        this.showLoader = false;
      }, error: (error: any) => {
        this.showLoader = false;
        this.errorMessage = this.errorHandler.GetErrorMessage("Reviewd Crawled Master Data", error.status);
        this.notifier.notify('error', this.errorMessage);
      }
    });
  }

  NavigateToSourceUrl(ID: any, Url: any) {

    if (Url && !Url.includes('http')) {
      // Url = 'https:' + Url;
      this.router.navigate([]).then(result => { window.open('https:/' + Url, '_blank'); });
    }
    else {
      this.router.navigate([]).then(result => { window.open(Url, '_blank'); });
    }

  }

  downloadXml(xmlData: any, fieldName: any) {
    const xmlContent = xmlData;
    if (xmlContent) {
      const blob = new Blob([xmlContent], { type: 'application/xml' });
      const url = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      // a.download = 'ReviewdCrewledData.xml';
      a.download = fieldName + '.xml';
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      URL.revokeObjectURL(url);
    }
  }

  ngOnInit(): void {
    this.pagination = new Pagination("ID", false, 1);
    this.pagination.pageLength = 50;
    this.GetClientMasterOptions();
    this.GetReviewCrawledDataSearch(this.pagination);
  }

  Search(filterForm: any) {
    this.errorMessage = null;
    if (filterForm.invalid || !this.pagination.masterSheetId && !this.pagination.URLConfigurationMasterID) {
      this.errorMessage = 'Please enter either MasterSheetID or URLConfigurationMasterID.';
      return;
    }
    this.SearchReviewCrawledData();
  }

  SearchReviewCrawledData() {
    this.pagination.pageIndex = 1;
    this.isSearch = true;
    this.pagination.ProcessDate = this.datePipe.transform(this.ProcessDate, 'MM/dd/YYYY');
    this.GetReviewCrawledDataSearch(this.pagination);
  }

  Reset() {
    this.isSearch = false;
    this.pagination.pageIndex = 1;
    this.pagination.pageLength = 50;
    this.pagination.searchText = "";
    this.pagination.URLConfigurationMasterID = null;
    this.pagination.masterSheetId = null;
    this.pagination.searchString = null;
    const tempClientID = this.clientMasterId;
    this.clientMasterId = null;
    this.pagination.clientMasterId = null;


    for (let i = 0; i < this.columnList.length; i++) {
      this.columnList[i].text = '';
    }
    for (let i = 0; i < this.columnDropdownFilter.length; i++) {
      this.columnDropdownFilter[i].activeURLConfigurationMasterID = false;
      this.columnDropdownFilter[i].activeMasterSheetId = false;
      this.columnDropdownFilter[i].activeClientName = false;
      this.columnDropdownFilter[i].activeRegLakeStatus = false;
      this.columnDropdownFilter[i].activePushToCMS = false;
      this.columnDropdownFilter[i].activeIsSeleniumRequired = false;
      this.columnDropdownFilter[i].activeCrawledMasterDataID = false;
      this.columnDropdownFilter[i].activeUrlDetailID = false;
      this.columnDropdownFilter[i].activeCreatedOn = false;
      this.columnDropdownFilter[i].activeCrawledJSONID = false;
      this.columnDropdownFilter[i].activeErrorMessage = false;
      this.columnDropdownFilter[i].activeSourceURLError = false;
      this.columnDropdownFilter[i].activeFieldLevelError = false;
      this.columnDropdownFilter[i].activeTotalReceivedRecords = false;
      this.columnDropdownFilter[i].activeProcessedRecords = false;
      this.columnDropdownFilter[i].activeErrorRecords = false;
      this.columnDropdownFilter[i].activeBrowserType = false;
      this.columnDropdownFilter[i].activeSourceURL = false;
      this.columnDropdownFilter[i].activeCrawledData = false;
    }
    this.GetReviewCrawledDataSearch(this.pagination);
    this.clientMasterId = tempClientID;
  }

  GetReviewCrawledDataSearchByPageLength() {
    this.pagination.pageIndex = 1;
    this.GetReviewCrawledDataSearch(this.pagination);
  }

  GetReviewCrawledDataSearch(paginationdetail: any) {

    this.errorMessage = null;
    if (paginationdetail) {
      this.pagination.pageIndex = paginationdetail.pageIndex;
      this.currentPage = this.pagination.pageIndex;
    }
    this.pagination.pageLength = this.pagination.pageLength;
    this.pagination.clientMasterId = this.clientMasterId;
    this.showLoader = true;
    this.reviewCrawledDataService.Get(this.pagination).subscribe({
      next: (data: any) => {
        this.showLoader = false;
        this.totalPages = data.Data.TotalPage;
        this.currentPage = data.Data.CurrentIndex;
        this.reviewCrawledDatalSearchList = data.Data.Data[0].uSP_ReviewCrawledData_Result1s;
        this.reviewCrawledDatalSearchList1 = data.Data.Data[0].uSP_ReviewCrawledData_Result2s;
        this.reviewCrawledDatalSearchList2 = data.Data.Data[0].uSP_ReviewCrawledData_Result3s;
        this.reviewCrawledDatalSearchList3 = data.Data.Data[0].uSP_ReviewCrawledData_Result4s;
        this.totalRecordsForPagination = data.Data.TotalRecordsForPagination;
      }, error: (error: any) => {
        this.showLoader = false;
        this.errorMessage = this.errorHandler.GetErrorMessage("Reviewd Crawled Master Data", error.status)
        this.notifier.notify('error', this.errorMessage);
      }
    });
  }

}